import {EntityApiService, ApiClientService} from '@dofleini/security';

class TemplatesApiService extends EntityApiService {

    addField = ({sectionId, ...params}) => {
      return ApiClientService.post(this.getPath(`/${sectionId}/field/add`), params);
    };

    updateField = ({sectionId, fieldId, ...params}) => {
      return ApiClientService.patch(this.getPath(`/${sectionId}/field/${fieldId}/update`), params);
    };

    deleteField = ({sectionId, fieldId}) => {
      return ApiClientService.delete(this.getPath(`/${sectionId}/field/${fieldId}/remove`));
    };

    changeFieldOrder= ({sectionId, fieldId, ...params}) => {
      return ApiClientService.patch(this.getPath(`/${sectionId}/param/${fieldId}/order`), params);
    }

    addParameter = ({sectionId, ...params}) => {
      return ApiClientService.post(this.getPath(`/${sectionId}/param/add`), params);
    };

    deleteParameter = (params) => {
      return ApiClientService.delete(this.getPath(`/${params.sectionId}/param/${params?.parameterId}/remove`), params);
    };

    changeSectionOrder = ({sectionId, ...params}) => {
      return ApiClientService.patch(this.getPath(`/${sectionId}/order`), params);
    }

    changeParameterOrder = ({sectionId, parameterId, ...params}) => {
      return ApiClientService.patch(this.getPath(`/${sectionId}/param/${parameterId}/order`), params);
    }

}

export default new TemplatesApiService('/ms-registry/api/register-sections');
